import { FC, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { DateRange } from '@mui/icons-material';

import { CustomAlert, CustomButton } from '../../../shared/uiComponents';
import { useRefreshProviderCancellations } from '../../../shared/Helpers/hooks';
import RequestCancellationModal from '../../Schedules/RequestTimeOffModal';
import { AdminTypes } from '../../../components/Menu';

import { DispatchProperties, useSelector } from '../../../redux/store';
import { getEvents } from '../../../redux/State/clientSlice/calendarSlice';

const AdminSetCancellation = () => {
	const [open, setOpen] = useState(false);
	const dispatch = useDispatch<DispatchProperties>();

	const role = useSelector((state) => state.account.role);
	const isAdmin = role?.section.id === AdminTypes.admin;
	const days = useSelector((state) => state.calendarHelper.displayedCalendarPageDays);
	const filterData = useSelector((state) => state.calendarHelper.filterData);
	const canFilterEvents = isAdmin || role?.section.id === AdminTypes.cs;
	const refreshCancellations = useRefreshProviderCancellations();

	const selectedProvider = filterData.therapist;

	if (!isAdmin || !selectedProvider?.id) return null;

	const handleSuccess = () => {
		setOpen(false);
		const eventData = canFilterEvents
			? { days, clientId: filterData.client?.id, userId: selectedProvider.id, includeBTEvents: filterData.includeBTEvents, includeBCBAEvents: filterData.includeBCBAEvents }
			: { days, includeBTEvents: filterData.includeBTEvents, includeBCBAEvents: filterData.includeBCBAEvents };
		dispatch(getEvents(eventData));
		refreshCancellations();
	};

	const AdminSetCancellationContent: FC<{ onClose: () => void }> = ({ onClose }) => (
		<RequestCancellationModal onClose={onClose} onSuccess={handleSuccess} providerId={selectedProvider.id} providerName={selectedProvider.fullName} />
	);

	return (
		<>
			<CustomButton
				title="Set Cancellation"
				buttonType="secondaryGray"
				onClick={() => setOpen(true)}
				className="requestCancellationButton"
			/>
			<CustomAlert
				open={open}
				onClose={() => setOpen(false)}
				title={selectedProvider.fullName ? `Set Cancellation – ${selectedProvider.fullName}` : 'Set Cancellation'}
				Icon={({ color }) => <DateRange htmlColor={color || '#1e3a5f'} />}
				compactHeaderIcon
				iconBackgroundColor="transparent"
				maxWidth="sm"
				disableBackdropClose
				Content={AdminSetCancellationContent}
			/>
		</>
	);
};

export default AdminSetCancellation;
